export const localeOptions = {
    US: "US",
    EU: "EU",
};
